"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.array.sort");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.typed.uint8-array");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.regexp.match");

var _apolloClient = require("@/apollo/apolloClient");

var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));

var _companyMutation = require("@/apollo/mutations/company-mutation");

var _userQuery = require("@/apollo/queries/user-query");

var _user = require("@/api/user");

var _v = _interopRequireDefault(require("uuid/v4"));

var _checkExt = require("../../utils/check-ext");

var _validate = require("@/utils/validate");

var _auth = require("@/utils/auth");

var _AffiliationGroup = _interopRequireDefault(require("./components/AffiliationGroup"));

var _vueAvatarCropper = _interopRequireDefault(require("vue-avatar-cropper"));

var _title_widget = _interopRequireDefault(require("@/views/widgets/title_widget.vue"));

var _constants = require("@/utils/constants");

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    AffiliationGroup: _AffiliationGroup.default,
    AvatarCropper: _vueAvatarCropper.default,
    TitleWidget: _title_widget.default,
    Button: _button_widget.default
  },
  mixins: [_FirebaseStorageUtil.default],
  data: function data() {
    var _this = this;

    var accountCheck = function accountCheck(rule, value, callback) {
      if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角英数字で入力してください'));
      } else {
        if (value.length < rule.minLen) {
          callback(error(rule.colname + 'は' + rule.minLen + '文字以上で入力してください'));
        } else if (value.length > rule.maxLen) {
          callback(error(rule.colname + 'は' + rule.maxLen + '文字以下で入力してください'));
        }

        _apolloClient.apolloClient.query({
          query: _userQuery.ACCOUNT_FOUND,
          variables: {
            id: value
          }
        }).then(function (result) {
          if (result.data.user.length > 0) {
            callback(new Error('すでに登録されているIDです。'));
          } else {
            callback();
          }
        }).catch(function (error) {
          callback(new Error(error));
        });
      }
    };

    var validateRequire = function validateRequire(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を入力してください'));
      } else {
        callback();
      }
    };

    var validateRequireEmployee = function validateRequireEmployee(rule, value, callback) {
      callback();
    };

    var validateRequireOption = function validateRequireOption(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を選択してください'));
      } else {
        callback();
      }
    };

    var checkHanEisu = function checkHanEisu(rule, value, callback) {
      if (!value) {
        callback(error(rule.colname + 'を入力してください'));
        return;
      } else if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角を入力してください。'));
      } else {
        if (value.length < rule.minLen) {
          callback(error('半角英数字' + rule.minLen + '桁以上を入力してください。'));
        }

        callback();
      }
    };

    var checkHanEisuEx = function checkHanEisuEx(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }

      if (_this.$data.form.password !== _this.$data.password_org) {
        if (_this.$data.form.password !== value) {
          callback(error('社員パスワードと社員パスワード（確認用）が異なります。'));
        }
      }

      callback();
    };

    var error = function error(message) {
      return new Error(message);
    };

    return {
      mark_description: '',
      description: {
        description_admin: '<div style="line-height: 1.8">チェックをONにすると「役割：一般」のユーザーからメッセージやアプリ内通話などの受信が受けられなくなります。</br>※すでにやりとりをした事があるユーザーからの連絡を受けることは可能です。</div>',
        description_staff: '<div style="line-height: 1.8">・チェックをONにすると「役割：一般」同士と連絡ができなくなります。</br>・チェックをOFFにすると「役割：一般」同士の公開ユーザーと連絡をすることが可能です。</div>'
      },
      datePickerOptions: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      role: {},
      dataCropper: {
        fileName: '',
        triggerCropImage: false,
        urlImage: ''
      },
      keyAffiliation: 0,
      pathAffiliationList: [],
      saveAffiliationList: [],
      drawer: false,
      company_id: null,
      fileAvatar: [],
      // アバター
      create_uid: '',
      phone_number: '',
      upload_fax: '',
      upload_mobile: '',
      upload_postcode: '',
      space: '　',
      form: {
        employee_id: '',
        uid: '',
        company_id: '',
        avatar: '',
        // 社員写真
        last_name: '',
        // 社員名（姓）
        last_name_furigana: '',
        // 社員名（ふりがな姓）
        name: '',
        // 社員名（名）
        name_furigana: '',
        // 社員名（ふりがな名）
        position: '',
        // 役職名
        others: '',
        // その他
        mobile_phone: '',
        // 携帯番号
        id: '',
        // ログインID
        password: '',
        // ログインパスワード
        confirmation_password: '',
        is_display: true,
        // アプリへの社員表示の有無
        is_active: true,
        // 社員の管理
        company: {
          id: '',
          // 会社ID
          website: '',
          // ホームページ
          business_descriptions: '',
          // 事業内容
          capital_stock: '',
          // 資本金
          email: '',
          // E-mail
          employees: '',
          // 社員数
          employees_part_time: '',
          // パート
          established: '',
          // 会社創立年月日
          fax1: '',
          // 会社FAX
          fax2: '',
          // 会社FAX
          fax3: '',
          // 会社FAX
          name: '',
          // 社員企業名
          name_furigana: '',
          // 社員企業名（ふりがな）
          address_1: '',
          // 会社住所
          address_2: '',
          // ビル名
          phone_number1: '',
          // 会社TEL
          phone_number2: '',
          // 会社TEL
          phone_number3: '',
          // 会社TEL
          join_date: '',
          // 入社年月
          industry: '',
          // 職種コード
          mobile_phone1: '',
          // 携帯番号
          mobile_phone2: '',
          // 携帯番号
          mobile_phone3: '',
          // 携帯番号
          postcode1: '',
          // 会社郵便番号
          postcode2: '',
          // 会社郵便番号
          industries: {
            id: '',
            // 職種ID
            name: '',
            // 職種
            group_id: '',
            // グループID
            code: ''
          },
          created_at: '' // 作成日時

        },
        personal_contact_authority: '',
        user_type: '',
        show_company_info: ''
      },
      waitDialogVisible: false,
      addDialogVisible: false,
      period: [{
        scope: ''
      }],
      textOrganization: '',
      textOrganizationShibu: '',
      textOrganizationChiku: '',
      errorMessageOrganization: '',
      planUser: {},
      props: [],
      defaultCheckedProps: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      role_permission: {
        textShowCheckBox: '',
        enablePrivateChat: false,
        showWindow: false
      },
      checkNumber: function checkNumber(rule, value, callback) {
        if (_this.isNumber(value) === false && value.length > 0) {
          callback(error(rule.colname + 'は半角数字で入力してください'));
        } else {
          callback();
        }
      },
      validateRequire: function validateRequire(rule, value, callback) {
        if (!_this.form.company.postcode1 && !_this.form.company.postcode2) {
          _this.$data.upload_postcode = (0, _v.default)();
          callback();
          return;
        }

        callback();
      },
      validateRequireEmployee: function validateRequireEmployee(rule, value, callback) {
        callback();
      },
      validateRequirePhone: function validateRequirePhone(rule, value, callback) {
        if (!_this.form.company.phone_number1 && !_this.form.company.phone_number2 && !_this.form.company.phone_number3) {
          _this.$data.phone_number = (0, _v.default)();
          callback();
          return;
        } else if (_this.form.company.phone_number1 || _this.form.company.phone_number2 || _this.form.company.phone_number3) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
            return;
          } else if (_this.isNumber(value) === false) {
            callback(error(rule.colname + 'は、半角数字で入力してください'));
            return;
          }
        }

        callback();
      },
      tel1: function tel1(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }

        callback();
      },
      tel2: function tel2(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }

        callback();
      },
      tel3: function tel3(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }

        callback();
      },
      postcode1: function postcode1(rule, value, callback) {
        if (_this.form.company.postcode1 || _this.form.company.postcode2) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
          } else if (_this.isNumber(value) === false) {
            callback(error('郵便番号は、半角数字で入力してください'));
            return;
          } else if (value.length !== 3) {
            callback(error(rule.colname + '桁数は３桁で入力してください'));
            return;
          }
        }

        callback();
      },
      postcode2: function postcode2(rule, value, callback) {
        if (_this.form.company.postcode1 || _this.form.company.postcode2) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
          } else if (_this.isNumber(value) === false) {
            callback(error('郵便番号は、半角数字で入力してください'));
            return;
          } else if (value.length !== 4) {
            callback(error(rule.colname + '桁数は4桁で入力してください'));
            return;
          }
        }

        callback();
      },
      validateRequireFax: function validateRequireFax(rule, value, callback) {
        if (_this.$data.form.company.fax1.length === 0 && _this.$data.form.company.fax2.length === 0 && _this.$data.form.company.fax3.length === 0) {
          _this.$data.upload_fax = (0, _v.default)();
          callback();
          return;
        } else if (_this.$data.form.company.fax1 || _this.$data.form.company.fax2 || _this.$data.form.company.fax3) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください。'));
            return;
          } else if (_this.isNumber(value) === false) {
            callback(error(rule.colname + 'は、半角数字で入力してください。'));
            return;
          }
        }

        callback();
      },
      validateRequireMobile: function validateRequireMobile(rule, value, callback) {
        if (_this.$data.form.company.mobile_phone1.length === 0 && _this.$data.form.company.mobile_phone2.length === 0 && _this.$data.form.company.mobile_phone3.length === 0) {
          _this.$data.upload_mobile = (0, _v.default)();
          callback();
          return;
        }

        if (_this.$data.form.company.mobile_phone1 || _this.$data.form.company.mobile_phone2 || _this.$data.form.company.mobile_phone3) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
            return;
          } else if (_this.isNumber(value) === false) {
            callback(error(rule.colname + 'は、半角数字で入力してください'));
            return;
          }
        }

        callback();
      },
      checkDate: function checkDate(rule, value, callback) {
        if (value === '' || value === null) {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      validateRequireOption: function validateRequireOption(rule, value, callback) {
        if (value === '') {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      email: function email(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
        }

        if (!value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }

        callback();
      },
      url: function url(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
        }

        if (!value.match(/(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }

        callback();
      },
      rules: {
        last_name: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（姓）'
        }],
        name: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（名）'
        }],
        last_name_furigana: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（ふりがな姓）'
        }],
        name_furigana: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（ふりがな名）'
        }],
        id: [{
          required: true,
          validator: accountCheck,
          colname: '社員ID',
          minLen: 4,
          maxLen: 8
        }],
        password: [{
          required: true,
          validator: checkHanEisu,
          colname: '社員パスワード',
          minLen: 4,
          maxLen: 4
        }],
        confirmation_password: [{
          required: true,
          validator: checkHanEisuEx,
          colname: '社員パスワード（確認用）',
          minLen: 4,
          maxLen: 8
        }],
        is_display: [{
          required: true,
          validator: validateRequireOption,
          colname: 'アプリへの社員表示の有無'
        }],
        show_company_info: [{
          required: true,
          validator: validateRequireOption,
          colname: 'アプリへのプロフィール情報'
        }],
        is_active: [{
          required: true,
          validator: validateRequireOption,
          colname: '社員の管理'
        }],
        user_type: [{
          required: true,
          validator: validateRequireOption,
          colname: 'ユーザーの役割'
        }],
        employee_id: [{
          required: false,
          validator: validateRequireEmployee,
          colname: '社員番号'
        }]
      }
    };
  },
  computed: {
    coms: function coms() {
      return this.$store.getters.companies;
    },
    industry_major: function industry_major() {
      return this.$store.getters.industryMajorOptions;
    },
    industry_middle: function industry_middle() {
      return this.$store.getters.industryMiddleOptions;
    },
    industry_info: function industry_info() {
      return this.$store.getters.industryInfo;
    },
    displays: function displays() {
      return this.$store.getters.displayOptions;
    },
    logins: function logins() {
      return this.$store.getters.loginOptions;
    },
    company: function company() {
      return this.$store.getters.company;
    },
    detail: function detail() {
      return this.$store.companyDetail;
    },
    userRoles: function userRoles() {
      return this.$store.getters.userRoles;
    }
  },
  created: function created() {},
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var roleType;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.commit('company/setEnableTextAllSelect', false);

            case 2:
              _context.next = 4;
              return this.$store.dispatch('company/clear');

            case 4:
              _context.next = 6;
              return this.$store.dispatch('company/getDisplayList');

            case 6:
              _context.next = 8;
              return this.$store.commit('company/setOptionValue', null);

            case 8:
              _context.next = 10;
              return this.$store.dispatch('company/getLoginList');

            case 10:
              _context.next = 12;
              return this.$store.dispatch('company/getIndustryMajorList');

            case 12:
              _context.next = 14;
              return this.$store.commit('company/pathToListItem', []);

            case 14:
              _context.next = 16;
              return this.$store.dispatch('company/getRoles');

            case 16:
              _context.next = 18;
              return (0, _auth.getUserPermission)();

            case 18:
              roleType = _context.sent;

              if (roleType) {
                this.role = JSON.parse(roleType);
              }

              this.$store.commit('company/setEnableTextAllSelect', false);
              _context.next = 23;
              return this.$store.dispatch('company/fetchAffiliation');

            case 23:
              this.getTreeProps();

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    onChangePermission: function onChangePermission(roleId) {
      var userRole = this.userRoles;
      this.role_permission.enablePrivateChat = false;

      if (!userRole || !userRole.length) {
        return;
      }

      var role = userRole.filter(function (item) {
        return item.id === roleId;
      });

      if (role.length) {
        var isRoleBlock = userRole.filter(function (item) {
          return item.is_default_role;
        });

        if (role[0].allow_ignore_blocking_chat) {
          this.role_permission.textShowCheckBox = "\u300C".concat(isRoleBlock[0].name, "\u300D\u30E6\u30FC\u30B6\u30FC\u304B\u3089\u306E\u9023\u7D61\u3092\u53D7\u4FE1\u3057\u306A\u3044");
          this.mark_description = this.description.description_admin;
        } else {
          this.role_permission.textShowCheckBox = "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30E6\u30FC\u30B6\u30FC\u306B\u3059\u308B";
          this.mark_description = this.description.description_staff;
        }

        this.role_permission.showWindow = role[0].allow_extend_role;
      }
    },
    getTreeProps: function getTreeProps() {
      var listData = [];

      function createDataByElTree(input) {
        return {
          id: input.id,
          label: input.name,
          children: input.affiliations.map(function (subItem) {
            return createDataByElTree(subItem);
          })
        };
      }

      listData = this.$store.getters.affiliations.map(function (item) {
        return createDataByElTree(item);
      });
      this.props = listData;
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        data.is_directly = true;
        this.pathAffiliationList.push(data);
      } else {
        this.pathAffiliationList.splice(this.pathAffiliationList.indexOf(data), 1);
      }
    },
    handleDialogQuestion: function () {
      var _handleDialogQuestion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(title, content, yes, no) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$confirm(content, title, {
                  confirmButtonText: yes,
                  cancelButtonText: no,
                  showCancelButton: false,
                  center: true
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleDialogQuestion(_x, _x2, _x3, _x4) {
        return _handleDialogQuestion.apply(this, arguments);
      }

      return handleDialogQuestion;
    }(),
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'CompanyIndex'
      });
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mime
      });
    },
    cropperHandler: function cropperHandler(cropper) {
      var getDataCanvas = cropper.getCroppedCanvas().toDataURL();
      this.dataCropper.urlImage = getDataCanvas;
      var file = this.dataURLtoFile(getDataCanvas, this.dataCropper.fileName);
      this.fileAvatar = [file];
    },
    handleUploading: function handleUploading(file, reader) {
      this.dataCropper.fileName = file.file.name;
    },
    handlerError: function handlerError(message, type, xhr) {
      this.$notify({
        title: 'エラー',
        message: '対応していないファイル形式です',
        type: 'error',
        duration: 2000
      });
    },
    deleteItemAffiliation: function deleteItemAffiliation(item, index) {
      // 父親が削除されると、子供も削除されます
      var indexSplice = 1;

      for (var i = index + 1; i < this.pathAffiliationList.length; i++) {
        if (this.pathAffiliationList[i].paddingFloorInTreeAffiliation > item.paddingFloorInTreeAffiliation) {
          indexSplice = indexSplice + 1;
        } else break;
      }

      this.pathAffiliationList.splice(index, indexSplice);
    },
    swapAffiliationComponent: function () {
      var _swapAffiliationComponent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(data) {
        var _this2 = this;

        var listPathOriginalAffiliation, pathFromDepth, setAffiliation;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.drawer = !this.drawer;
                if (this.drawer) this.$store.commit('company/pathToListItem', []);else this.keyAffiliation++;
                listPathOriginalAffiliation = this.$store.getters.pathToListItem;

                if (!(listPathOriginalAffiliation.length !== 0 && listPathOriginalAffiliation && this.drawer === false)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 6;
                return (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, listPathOriginalAffiliation);

              case 6:
                pathFromDepth = _context3.sent;

                if (this.pathAffiliationList.length !== 0) {
                  setAffiliation = pathFromDepth.filter(function (val) {
                    return _this2.pathAffiliationList.some(function (entire) {
                      return val.id === entire.id;
                    }) === false;
                  });
                  if (setAffiliation.length !== 0) setAffiliation.forEach(function (item) {
                    return _this2.pathAffiliationList.push(item);
                  });
                } else this.pathAffiliationList = pathFromDepth;

                this.pathAffiliationList.sort(function (a, b) {
                  return a.idFake - b.idFake;
                }); // / 所属している組織ときに通知を表示または非表示にする

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function swapAffiliationComponent(_x5) {
        return _swapAffiliationComponent.apply(this, arguments);
      }

      return swapAffiliationComponent;
    }(),
    changeIndustryMajor: function () {
      var _changeIndustryMajor = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$store.dispatch('company/getIndustryMiddleList', {
                  group_id: this.$data.form.company.industries.group_id
                });

              case 2:
                this.$data.form.company.industry = this.$store.getters.industryMiddleOptions[0].code;

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function changeIndustryMajor() {
        return _changeIndustryMajor.apply(this, arguments);
      }

      return changeIndustryMajor;
    }(),
    getExtension: function getExtension(fileName) {
      var ret;

      if (!fileName) {
        return ret;
      }

      var fileTypes = fileName.split('.');
      var len = fileTypes.length;

      if (len === 0) {
        return ret;
      }

      ret = fileTypes[len - 1];
      return ret;
    },
    handleRemoveAvatar: function handleRemoveAvatar(file, fileList) {
      this.log('handleRemoveAvatar');
      this.fileAvatar = fileList;
    },
    handleDeleteAvatar: function handleDeleteAvatar(file, fileList) {
      this.log('handleDeleteAvatar');
      this.dataCropper.urlImage = '';
      this.fileAvatar = [];
    },
    handleAddAvatar: function handleAddAvatar(file, fileList) {
      this.log('handleAddAvatar');

      if ((0, _checkExt.checkExtImage)(file.name)) {
        this.fileAvatar = fileList;
      } else {
        this.fileAvatar = [];
        this.$refs.upload.clearFiles();
        this.$notify({
          title: 'エラー',
          message: '対応していないファイル形式です',
          type: 'error',
          duration: 2000
        });
      }
    },
    planUserCheck: function () {
      var _planUserCheck = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var planData, content;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$store.dispatch('company/getPlanUser');

              case 2:
                planData = _context5.sent;

                if (!planData) {
                  _context5.next = 9;
                  break;
                }

                if (!planData.warning_when_reach_max_user) {
                  _context5.next = 9;
                  break;
                }

                if (!(planData.user_count >= planData.max_user)) {
                  _context5.next = 9;
                  break;
                }

                content = "".concat(planData.name, "\u3067\u306F").concat(planData.max_user, "\u540D\u9650\u5B9A\u3067\u3059\u3002");
                this.handleDialogQuestion('確認', content, 'OK');
                return _context5.abrupt("return", true);

              case 9:
                return _context5.abrupt("return", false);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function planUserCheck() {
        return _planUserCheck.apply(this, arguments);
      }

      return planUserCheck;
    }(),
    postFromCheck: function postFromCheck() {
      var _this3 = this;

      this.log(this.form); // エラーが発生した場合は停止します

      this.$refs['form'].validate(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(valid) {
          var questionYesOrNo;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!valid) {
                    _context6.next = 11;
                    break;
                  }

                  _context6.next = 3;
                  return _this3.planUserCheck();

                case 3:
                  if (!_context6.sent) {
                    _context6.next = 5;
                    break;
                  }

                  return _context6.abrupt("return");

                case 5:
                  _context6.next = 7;
                  return (0, _constants.message_box_confirm)('確認', '登録後に、「社員名簿」の一覧にて、ご登録された者の名前で検索頂き、「ユーザーID」をご確認出来ます。よろしいですか？', '登録', 'message_default');

                case 7:
                  questionYesOrNo = _context6.sent;

                  if (questionYesOrNo) {
                    _this3.onAdd();
                  }

                  _context6.next = 13;
                  break;

                case 11:
                  _this3.log('error submit!!');

                  return _context6.abrupt("return", false);

                case 13:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x6) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    onAdd: function () {
      var _onAdd = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8() {
        var _this4 = this;

        var employees, employees_part_time, established, join_date, phoneNumber, mobilePhone, fax, postCode, objects, fileAvatarURL;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.waitDialogVisible = true;
                this.addDialogVisible = false;
                employees = 0;

                if (this.$data.form.company.employees === '' || this.$data.form.company.employees === null || this.$data.form.company.employees === undefined) {
                  employees = null;
                } else {
                  employees = this.$data.form.company.employees;
                }

                employees_part_time = 0;

                if (this.$data.form.company.employees_part_time === '' || this.$data.form.company.employees_part_time === null || this.$data.form.company.employees_part_time === undefined) {
                  employees_part_time = null;
                } else {
                  employees_part_time = this.$data.form.company.employees_part_time;
                }

                established = null;

                if (this.$data.form.company.established === '' || this.$data.form.company.established === null || this.$data.form.company.established === undefined) {
                  established = null;
                } else {
                  established = new Date(this.$data.form.company.established).toLocaleString({
                    timeZone: 'Asia/Tokyo'
                  });
                }

                join_date = null;

                if (this.$data.form.company.join_date) {
                  join_date = new Date(this.$data.form.company.join_date).toLocaleString({
                    timeZone: 'Asia/Tokyo'
                  });
                }

                phoneNumber = null;

                if (this.$data.form.company.phone_number1 && this.$data.form.company.phone_number2 && this.$data.form.company.phone_number3) {
                  phoneNumber = this.$data.form.company.phone_number1 + '-' + this.$data.form.company.phone_number2 + '-' + this.$data.form.company.phone_number3;
                }

                mobilePhone = null;

                if (this.$data.form.company.mobile_phone1 && this.$data.form.company.mobile_phone2 && this.$data.form.company.mobile_phone3) {
                  mobilePhone = this.$data.form.company.mobile_phone1 + '-' + this.$data.form.company.mobile_phone2 + '-' + this.$data.form.company.mobile_phone3;
                }

                fax = null;

                if (this.$data.form.company.fax1 && this.$data.form.company.fax2 && this.$data.form.company.fax3) {
                  fax = this.$data.form.company.fax1 + '-' + this.$data.form.company.fax2 + '-' + this.$data.form.company.fax3;
                }

                postCode = null;

                if (this.$data.form.company.postcode1 && this.$data.form.company.postcode2) {
                  postCode = this.$data.form.company.postcode1 + '-' + this.$data.form.company.postcode2;
                }

                objects = [{
                  avatar: fileAvatarURL,
                  last_name: this.$data.form.last_name.toString().trim(),
                  last_name_furigana: this.$data.form.last_name_furigana.toString().trim(),
                  name: this.$data.form.name.toString().trim(),
                  name_furigana: this.$data.form.name_furigana.toString().trim(),
                  position: this.$data.form.position,
                  others: this.$data.form.others,
                  mobile_phone: this.$data.form.mobile_phone,
                  password: (0, _user.encrypt)(this.$data.form.password),
                  is_display: this.$data.form.is_display,
                  is_active: this.$data.form.is_active,
                  employee_id: this.$data.form.employee_id,
                  role_id: this.form.user_type,
                  show_company_info: this.form.show_company_info,
                  company: {
                    data: {
                      name: this.$data.form.company.name.toString().trim(),
                      name_furigana: this.$data.form.company.name_furigana.toString().trim(),
                      phone_number: phoneNumber,
                      mobile_phone: mobilePhone,
                      fax: fax,
                      email: this.$data.form.company.email,
                      website: this.$data.form.company.website,
                      postcode: postCode,
                      address_1: this.$data.form.company.address_1,
                      address_2: this.$data.form.company.address_2,
                      business_descriptions: this.$data.form.company.business_descriptions,
                      capital_stock: this.$data.form.company.capital_stock,
                      employees: employees,
                      employees_part_time: employees_part_time,
                      established: established,
                      join_date: join_date
                    }
                  }
                }];
                _context8.next = 21;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.ADD_MEMBER,
                  variables: {
                    objects: objects
                  }
                }).then(
                /*#__PURE__*/
                function () {
                  var _ref2 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee7(result) {
                    var userRole, roleBlock, user_role_chat, objectsAffilication, listAffiliationId, pathFromDepth;
                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _this4.create_uid = result.data.insert_user.returning[0].uid;

                            if (!(_this4.role_permission.showWindow && _this4.role_permission.enablePrivateChat)) {
                              _context7.next = 9;
                              break;
                            }

                            userRole = _this4.userRoles;

                            if (!(!userRole || !userRole.length)) {
                              _context7.next = 5;
                              break;
                            }

                            return _context7.abrupt("return");

                          case 5:
                            roleBlock = userRole.filter(function (item) {
                              return item.is_default_role;
                            });
                            user_role_chat = [{
                              user_id: _this4.create_uid,
                              role_id_block: roleBlock[0].id,
                              is_active: true
                            }];
                            _context7.next = 9;
                            return _this4.$store.dispatch('company/INSERT_USER_ROLE_CHAT_POLICY_MUTATE', user_role_chat).catch(function (error) {
                              _this4.waitDialogVisible = false;

                              _this4.$notify({
                                title: 'エラー',
                                message: '登録に失敗しました。',
                                type: 'error',
                                duration: 10000,
                                showClose: true
                              });

                              console.log(error);
                              throw error;
                            });

                          case 9:
                            objectsAffilication = [];
                            listAffiliationId = [];

                            if (!(_this4.pathAffiliationList.length !== 0 && _this4.pathAffiliationList)) {
                              _context7.next = 17;
                              break;
                            }

                            pathFromDepth = (0, _validate.depthFirstSearch)(_this4.$store.getters.affiliations, _this4.pathAffiliationList);
                            pathFromDepth.map(function (item) {
                              listAffiliationId.push(item.id);
                              objectsAffilication.push({
                                affiliation_id: item.id,
                                user_id: _this4.create_uid,
                                is_directly: Boolean(item.is_directly)
                              });
                            });

                            _apolloClient.apolloClient.mutate({
                              mutation: _companyMutation.USER_AFFILIATION_INSERT_UPDATE,
                              variables: {
                                user_id: _this4.create_uid,
                                affiliation_ids: listAffiliationId,
                                objects: objectsAffilication
                              }
                            }).then(function () {
                              _this4.waitDialogVisible = false;

                              _this4.$notify({
                                title: '情報',
                                message: '登録に成功しました。',
                                type: 'success',
                                duration: 2000
                              });

                              return _this4.$router.push({
                                name: 'CompanyIndex'
                              });
                            }).catch(function (error) {
                              console.log(error);
                            });

                            _context7.next = 21;
                            break;

                          case 17:
                            _this4.log(JSON.stringify(objectsAffilication));

                            _this4.waitDialogVisible = false;

                            _this4.$notify({
                              title: '情報',
                              message: '登録に成功しました。',
                              type: 'success',
                              duration: 2000
                            });

                            return _context7.abrupt("return", _this4.$router.push({
                              name: 'CompanyIndex'
                            }));

                          case 21:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x7) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  _this4.waitDialogVisible = false;
                  console.log(error);

                  _this4.$notify({
                    title: '情報',
                    message: '登録に失敗しました。',
                    type: 'error',
                    duration: 2000
                  });

                  _this4.log(error);

                  return;
                });

              case 21:
                fileAvatarURL = null;

                if (!(this.fileAvatar.length > 0)) {
                  _context8.next = 32;
                  break;
                }

                _context8.next = 25;
                return this.uploadFileToStorage(this.fileAvatar[0], 'users/avatar/avatar_' + this.create_uid + '.jpg');

              case 25:
                fileAvatarURL = _context8.sent;

                if (!(fileAvatarURL == null)) {
                  _context8.next = 30;
                  break;
                }

                console.log('画像のアップロードに失敗しました。');
                this.waitDialogVisible = false;
                return _context8.abrupt("return");

              case 30:
                _context8.next = 32;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.UPDATE_MEMBER,
                  variables: {
                    uid: this.create_uid,
                    objects: {
                      avatar: fileAvatarURL
                    }
                  }
                }).catch(function (error) {
                  _this4.$notify({
                    title: '情報',
                    message: '社員情報の更新に失敗しました。',
                    type: 'error',
                    duration: 2000
                  });

                  _this4.waitDialogVisible = false;

                  _this4.log(error);

                  return;
                });

              case 32:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function onAdd() {
        return _onAdd.apply(this, arguments);
      }

      return onAdd;
    }(),
    isNumber: function isNumber(val) {
      var regex = new RegExp(/^[0-9]+$/);
      return regex.test(val);
    },
    isHanEisu: function isHanEisu(str) {
      str = str === null ? '' : str;

      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    },
    log: function log(text) {}
  }
};
exports.default = _default;